class CustomSearch {

    constructor(options = {}) {

        this.shop = options.shop || Shopify.shop;
        this.token = options.token;

        this.endpoint = `https://${this.shop}/api/2025-07/graphql.json`;

        this.products = [];

        this.cursor = null;

        this.hasNextPage = true;

        // Cache config
        this.cacheKey = options.cacheKey || "customSearchIndex";

        this.cacheTTL = options.cacheTTL || 60 * 60 * 1000; // 1 hour default

    }

    async buildIndex(forceRefresh = false) {

        if (!forceRefresh) {

            const cached = this.loadFromCache();

            if (cached) {

                this.products = cached;

                console.log(`Loaded ${this.products.length} products from cache`);

                return this.products;

            }

        }

        this.products = [];

        this.cursor = null;

        this.hasNextPage = true;

        while (this.hasNextPage) {

            await this.fetchBatch();

        }

        this.products.sort((a, b) => a.title.localeCompare(b.title));

        this.saveToCache();

        console.log(`Indexed ${this.products.length} products (fresh fetch)`);

        return this.products;

    }

    loadFromCache() {

        try {

            const raw = localStorage.getItem(this.cacheKey);

            if (!raw) return null;

            const parsed = JSON.parse(raw);

            if (!parsed.timestamp || !parsed.products) return null;

            if (Date.now() - parsed.timestamp > this.cacheTTL) {

                localStorage.removeItem(this.cacheKey);

                return null;

            }

            return parsed.products;

        } catch (e) {

            console.error("CustomSearch: cache read failed", e);

            return null;

        }

    }

    saveToCache() {

        try {

            localStorage.setItem(this.cacheKey, JSON.stringify({

                timestamp: Date.now(),

                products: this.products

            }));

        } catch (e) {

            // Likely storage full/private mode - fail silently, cache is optional

            console.warn("CustomSearch: cache write failed", e);

        }

    }

    async fetchBatch() {

        const query = `
        query GetProducts($cursor: String){

            products(
                first:250,
                after:$cursor,
                sortKey:TITLE
            ){

                pageInfo{
                    hasNextPage
                    endCursor
                }

                edges{

                    node{

                        id
                        title
                        handle

                        availableForSale

                        featuredImage{
                            url
                        }

                        priceRange{
                            minVariantPrice{
                                amount
                                currencyCode
                            }
                        }

                    }

                }

            }

        }
        `;

        const response = await fetch(this.endpoint, {

            method: "POST",

            headers: {

                "Content-Type": "application/json",

                "X-Shopify-Storefront-Access-Token": this.token

            },

            body: JSON.stringify({

                query,

                variables: {

                    cursor: this.cursor

                }

            })

        });

        const json = await response.json();

        if (json.errors) {

            console.error(json.errors);

            return;

        }

        const data = json.data.products;

        this.hasNextPage = data.pageInfo.hasNextPage;

        this.cursor = data.pageInfo.endCursor;

        data.edges.forEach(edge => {

            this.products.push({

                id: edge.node.id,

                title: edge.node.title,

                handle: edge.node.handle,

                available: edge.node.availableForSale,

                image: edge.node.featuredImage
                    ? edge.node.featuredImage.url
                    : "",

                price: edge.node.priceRange.minVariantPrice.amount,

                currency: edge.node.priceRange.minVariantPrice.currencyCode

            });

        });

    }

    search(keyword) {

    keyword = keyword.trim().toLowerCase();

    if (!keyword.length) return [];

    let results = this.products.filter(product =>
        product.title.toLowerCase().includes(keyword)
    );

    results.sort((a, b) => {

        const A = a.title.toLowerCase();
        const B = b.title.toLowerCase();

        // 1. Exact title match
        if (A === keyword && B !== keyword) return -1;
        if (B === keyword && A !== keyword) return 1;

        // 2. Starts with search
        if (A.startsWith(keyword) && !B.startsWith(keyword)) return -1;
        if (B.startsWith(keyword) && !A.startsWith(keyword)) return 1;

        // 3. Word starts with search
        const aWord = A.split(" ").some(w => w.startsWith(keyword));
        const bWord = B.split(" ").some(w => w.startsWith(keyword));

        if (aWord && !bWord) return -1;
        if (bWord && !aWord) return 1;

        // 4. Shorter titles first
        if (A.length !== B.length)
            return A.length - B.length;

        // 5. Alphabetical
        return A.localeCompare(B);

    });

    return results;

}

}